<style>
  .tv_spots {
    font-family: 'montserrat';
    border-collapse: collapse;
    width: 300px;
    margin-left:auto; 
    margin-right:auto;
    margin-top: 4rem;
  }



  td, .tv_spots th {
    border-bottom: 1px solid #ddd;
    padding: 8px;
  }

  tr:nth-child(even){background-color: #f2f2f2;}

  tr:hover {background-color: #ddd;}

  th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: white;
    color: black;
  }
  button.make-bid {
    font-weight: 600;
    background: rgb(246, 246, 246);
    color: rgb(20, 20, 20);
    border-radius: 10px;
    border: 1px black solid;
    padding: 0.2rem;
    cursor: pointer;
  }
  .msg {
    width: 75%;
    padding: 0 3rem;
  }
</style>

<script>
  import {getToken} from "../js-core/conn/auth/auth-main"
  import { setContext } from 'svelte';
  import ButtonPopupImg from "../components/shared/buttons/ButtonPopupImg.svelte"
  let loading, errMsg, successMsg, allTvsNoPriorBid = [], checked = {}, singleMatchedSpot = false
  function inPotentialDisplayingTVs(adId, potentTVs, displayingTVs) {
    return potentTVs.indexOf(adId) !== -1 || displayingTVs.indexOf(adId) !== -1
  }
  async function placeBid() {
    const adId = getAdId()
    const tvIdsWithBid = allTvsNoPriorBid.filter((item, index) => {
      return checked[index] === true
    }).map(item => item._id)
    const res = await BSFetch(`ad-owner/tv-bid`, {
        method: "POST",
      headers: {
        authorization: getToken(),
        "Content-Type": "application/json"
      },
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify({ 
        tvIds: tvIdsWithBid,
        adId
      })
    })
    if (res.status === 204) {
       location.reload();
    } else if (res.status === 400) {
      const resBody = await res.json()
      errMsg = resBody.response.status
    } else {
      errMsg = "There was an error placing your bids"
    }
    loading = false
  }
  async function getRecSpots() {
		try {
			const adId = getAdId()
			const res = await BSFetch(`ad-owner/find-matching/${adId}`, {
				method: "GET",
        headers: {
          authorization: getToken(),
          "Content-Type": "application/json"
        },
        mode: "cors",
        cache: "no-cache"
      })
			if (res.status === 200) {
        const resBody = await res.json()
        const recSpots = resBody.response
				if (!recSpots) throw "no return"
        const tvIdsWithNoBid = recSpots.matchedAdToTV[0].matchedTVs.filter(matchedTv => {
          console.log(matchedTv, recSpots.matchedAdToTV[0])
          return !inPotentialDisplayingTVs(matchedTv._id, recSpots.matchedAdToTV[0].potentialTVs, recSpots.matchedAdToTV[0].displayingTVs)
        })
        allTvsNoPriorBid = tvIdsWithNoBid
        return allTvsNoPriorBid
      } else if (res.status === 400 || res.status === 404) {
        const resBody = await res.json()
        throw resBody.response.status
			} else {
				throw "There was an error the campaign info"
			}
		} catch (e) {
			console.error(e)
			throw e
		}
  }
  let getRecSpotsProm = getRecSpots()
</script>

<div class="Page_Title">
  <span>Bid on TV Spots</span>
</div>
  {#await getRecSpotsProm}
    Loading your recommended Brite Hosts...
  {:then matchedTVs}
    <table class="tv_spots">
    <!-- <p>
      Total Budget: ${ad.adBudgetTotal}
    </p>
    <p>
      Budget Spent: ${ad.adBudgetTotal - ad.adBudgetLeft}
    </p> -->
    {#if matchedTVs.length > 0}
      <tr>
        <th>Business Name</th>
        <!-- <th>Address</th> -->
        <th>View Images of TV</th>
	<th>Cost</th>
        <th>Bid on Brite Host</th>
      </tr>
    {:else}
      Looks like there are no more Brite Hosts which you have not already bid on! Please check back in later.
    {/if}
    {#each matchedTVs as matchedTV, index}
      <!-- check to make sure that the tv is not already in potential tvs -->
      <tr class="{checked[index] ? 'Grey_Out' : ''}" >
      <!-- TODO put in demographics -->
        <td>{matchedTV.businessName}</td>
        <!-- <td>jtjslaengogprjfkd</td> -->
        <td>
          <ButtonPopupImg height=200 id={matchedTV.profileImages.map(profPic => profPic.id)} buttonHtml="Brite Host Pictures" />
        </td>
	<td>
	  ${matchedTV.cost}
	</td>
        <td>
            <input type="checkbox" value="{index}" bind:checked={checked[index]}><br>
        </td>
      </tr>
    {/each}
    {#if matchedTVs.length > 0}
      <button class="action {loading ? 'loading' : ''}" on:click={() => placeBid()}>
        Bid on Brite Host
      </button>
    {/if}
    </table>
    <div class="msg">
      {#if errMsg}
        <p>
          {errMsg}
        </p>
      {:else if successMsg}
        <p>
          {successMsg}
        </p>
      {/if}
    </div>
  {:catch error}
    {error}
  {/await}
